import React from "react";
import {
  CreateVideoMeetingButton,
  UpdateVideoMeetingButton,
} from "../components/VideoMeetingActionButton";
import useEventModal from "./useEventModal";

const useVideoMeetingModal = props => {
  const {
    t,
    isModalOpen,
    setIsModalOpen,
    isFullScreenModal,
    setIsFullScreenModal,
    closeModal,
    openFullScreenModal,
    showModal,
    mode,
    closeFullScreenModal,
    isConfirmationModalOpen,
    onDiscardingChanges,
    onCancelDiscardingChanges,
    isEditMode,
    showFullScreenLoader,
    isCreateMode,
    isDevUser,
    isRepeatEvent,
    setShowFullScreenLoader,
  } = useEventModal(props);

  const actionButtons = {
    edit: (
      <UpdateVideoMeetingButton
        onClick={onDiscardingChanges}
        setShowFullScreenLoader={setShowFullScreenLoader}
      />
    ),
    create: (
      <CreateVideoMeetingButton
        onClick={onDiscardingChanges}
        setShowFullScreenLoader={setShowFullScreenLoader}
      />
    ),
  };

  return {
    t,
    isModalOpen,
    setIsModalOpen,
    isFullScreenModal,
    setIsFullScreenModal,
    closeModal,
    openFullScreenModal,
    showModal,
    mode,
    closeFullScreenModal,
    isConfirmationModalOpen,
    onDiscardingChanges,
    onCancelDiscardingChanges,
    isEditMode,
    actionButtons,
    showFullScreenLoader,
    isCreateMode,
    isDevUser,
    isRepeatEvent,
  };
};

export default useVideoMeetingModal;
